import React from 'react'

const HairMaskTips = () => {
  return (
    <div>
      
    </div>
  )
}

export default HairMaskTips
